import { Sidebar } from "../navigations/sidebar";


export const DashboardLayout = ({ showSidebar, setShowSidebar, children }) => {
  return (
    <div className="h-screen bg-navy-900 text-sm text-gray-100 font-body">
      {/* ===== Subtle Grid Background ===== */}
      <div
        className="fixed inset-0 z-0 pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0, 180, 216, 0.02) 1px, transparent 1px), linear-gradient(90deg, rgba(0, 180, 216, 0.02) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
        aria-hidden="true"
      />

      {/* ===== Top Ambient Glow ===== */}
      <div
        className="fixed top-0 left-1/2 -translate-x-1/2 w-[800px] h-[300px] pointer-events-none z-0"
        style={{
          background: "radial-gradient(ellipse, rgba(0, 180, 216, 0.06) 0%, transparent 70%)",
          filter: "blur(40px)",
        }}
        aria-hidden="true"
      />

      {/* ===== Sidebar ===== */}
      <Sidebar showSidebar={showSidebar} setShowSidebar={setShowSidebar} />

      {/* ===== Mobile Overlay ===== */}
      <div
        className={`fixed inset-0 z-10  bg-black/60 backdrop-blur-sm lg:hidden transition-all duration-300 ${
          showSidebar
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
        onClick={() => setShowSidebar(false)}
        aria-hidden="true"
      />

      {/* ===== Main Content Area ===== */}
      <div
        className={`relative z-10 h-screen transition-all duration-300 ease-out ${
          showSidebar ? "lg:ml-64" : "lg:ml-20"
        }`}
      >
        {children}
      </div>
    </div>
  );
};